import React from "react";
import { Row, Col } from "antd";
import sdgood from "../../assets/banner/sandee_good.png";

export default function SandeeLogo() {
  return (
    <div className="pclm-mascot-section">
      <Row className="pclm-mascot-wrapper" style={{ display: "flex", alignItems: "center" }}>
        <Col lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
          <div className="pclm-mascot-background"></div>
          <img src={sdgood} alt="SANDEE Mascot" className="pclm-mascot-image" />
        </Col>
        <Col lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
          <div>
            <h1 className="pclm-main-title">SANDEE Chatbot</h1>
            <h2 className="pclm-sub-title">Open Ticket | PC Lifecycle Management</h2>
          </div>
        </Col>
      </Row>
    </div>
  );
}
